module.exports = __webpack_public_path__ + "static/media/unicorn.4be2c186.svg";